import React from 'react';
import { Heart, Music, Users, UserCheck, Globe, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const WelcomeSection = () => {
  const { t } = useLanguage();

  const cards = [
    {
      icon: Music,
      title: t('welcome.card1Title'),
      desc: t('welcome.card1Desc'),
      gradient: 'from-sky-500 to-blue-600',
      bgLight: 'bg-sky-50',
    },
    {
      icon: Users,
      title: t('welcome.card2Title'),
      desc: t('welcome.card2Desc'),
      gradient: 'from-emerald-500 to-teal-600',
      bgLight: 'bg-emerald-50',
    },
    {
      icon: UserCheck,
      title: t('welcome.card3Title'),
      desc: t('welcome.card3Desc'),
      gradient: 'from-amber-500 to-orange-600',
      bgLight: 'bg-amber-50',
    },
    {
      icon: Globe,
      title: t('welcome.card4Title'),
      desc: t('welcome.card4Desc'),
      gradient: 'from-violet-500 to-purple-600',
      bgLight: 'bg-violet-50',
    },
  ];

  return (
    <section id="welcome" className="py-20 bg-white" data-testid="welcome-section">
      <div className="container mx-auto px-4">
        {/* Badge */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-red-50 border border-red-100 rounded-full mb-6">
            <Heart className="w-4 h-4 text-red-500" />
            <span className="text-sm font-semibold text-red-700" data-testid="welcome-badge">
              {t('welcome.badge')}
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {t('welcome.title')}
          </h2>
          <div className="w-20 h-1 bg-[#0f2440] mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            {t('welcome.subtitle')}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {cards.map((card, index) => (
            <div
              key={index}
              data-testid={`welcome-card-${index}`}
              className="group bg-white border border-gray-100 rounded-2xl p-7 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className={`w-14 h-14 bg-gradient-to-br ${card.gradient} rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                <card.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {card.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {card.desc}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button
            onClick={() => document.getElementById('visit')?.scrollIntoView({ behavior: 'smooth' })}
            data-testid="welcome-cta"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#0f2440] text-white rounded-xl font-semibold hover:bg-[#1a3a5c] transition-all hover:scale-105 hover:shadow-xl text-lg"
          >
            {t('welcome.cta')}
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
